export default (videoElement, subtitleTrack) => {
  const trackElement = document.createElement('track');
  trackElement.src = subtitleTrack;
  trackElement.srclang = 'nl';
  trackElement.label = 'Nederlands';

  return trackElement;
};
